import config from '~/common/config/config'
import { useGlobalContext } from '~/common/hooks/useGlobalContext'

/**
 * Who can see Data Sources.
 * Everyone outside production, and internal Doss users in production.
 */
export const useCanViewDataSources = () => {
  const { isInternal } = useGlobalContext()
  return !config.isProduction || isInternal
}
